'use client';

import {
  APPINITEvent,
  identifyUser,
  trackEvent,
  withBrazeRSState,
} from '@otter-ai/telemetry';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { loginInfoQueryCreator, userProfileQueryCreator } from '#query';
import packageJson from '../../../package.json';
import {
  getThirdPartyScriptsGlobal,
  initializeBraze,
} from '../../initializers.ts';

export function AnalyticsProvider() {
  const [isInitialized, setIsInitialized] = useState(false);

  const { data: loginData } = useQuery(loginInfoQueryCreator());
  const { data: user } = useQuery(
    userProfileQueryCreator({ enabled: loginData?.['logged-in'] === true }),
  );

  useEffect(() => {
    // most of the logic is based on the main.ts from angular client package
    const initializeAnalytics = async () => {
      try {
        withBrazeRSState(() => {
          initializeBraze();
        });

        setIsInitialized(true);
      } catch (error) {
        console.error('Failed to initialize analytics:', error);
      }
    };

    initializeAnalytics();

    trackEvent(APPINITEvent({ AppVersion: packageJson.version }));
  }, []);

  useEffect(() => {
    if (!isInitialized) return;

    if (user?.userid) {
      identifyUser({ id: user.userid, email: user.email });
      withBrazeRSState(() => {
        try {
          getThirdPartyScriptsGlobal().braze?.changeUser(String(user.userid));
        } catch (e) {
          console.error(e);
        }
      });
    }
  }, [user?.userid, user?.email, isInitialized]);

  return null;
}
